// src/components/EquipmentManager/OverviewTab.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { FaExternalLinkAlt, FaInfoCircle, FaTools } from 'react-icons/fa';
import styles from './OverviewTab.module.css';

const OverviewTab = ({ equipment }) => {
  return (
    <div className={styles.overviewTab}>
      {/* Description */}
      {equipment.description && (
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <FaInfoCircle /> Description
          </h3>
          <p className={styles.description}>{equipment.description}</p>
        </div>
      )}
      
      {/* Sponsor Information */}
      {equipment.sponsorInfo?.name && (
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Sponsor Information</h3>
          <div className={styles.sponsorCard}>
            {equipment.sponsorInfo.logo && (
              <div className={styles.sponsorLogo}>
                <img src={equipment.sponsorInfo.logo} alt={equipment.sponsorInfo.name} />
              </div>
            )}
            <div className={styles.sponsorDetails}>
              <h4>{equipment.sponsorInfo.name}</h4>
              {equipment.sponsorInfo.website && (
                <a 
                  href={equipment.sponsorInfo.website} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.sponsorLink}
                >
                  Visit Website <FaExternalLinkAlt />
                </a>
              )}
              {equipment.sponsorInfo.contactEmail && (
                <p className={styles.contactEmail}>
                  Contact: {equipment.sponsorInfo.contactEmail}
                </p>
              )}
            </div>
          </div>
        </div>
      )}
      
      {/* Purchase Options */}
      {(equipment.purchaseLinks?.amazon || 
        equipment.purchaseLinks?.directStore || 
        equipment.purchaseLinks?.otherLinks?.length > 0) && (
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Where to Buy</h3>
          <div className={styles.purchaseOptions}>
            {equipment.purchaseLinks?.amazon && (
              <a 
                href={equipment.purchaseLinks.amazon}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.purchaseLink}
              >
                <div className={styles.linkIcon}>🛒</div>
                <div className={styles.linkInfo}>
                  <span className={styles.linkTitle}>Amazon</span>
                  <span className={styles.linkSubtitle}>Fast shipping available</span>
                </div>
                <FaExternalLinkAlt className={styles.linkArrow} />
              </a>
            )}
            
            {equipment.purchaseLinks?.directStore && (
              <a 
                href={equipment.purchaseLinks.directStore}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.purchaseLink}
              >
                <div className={styles.linkIcon}>🏪</div>
                <div className={styles.linkInfo}>
                  <span className={styles.linkTitle}>Direct Store</span>
                  <span className={styles.linkSubtitle}>Buy from manufacturer</span>
                </div>
                <FaExternalLinkAlt className={styles.linkArrow} />
              </a>
            )}
            
            {equipment.purchaseLinks?.otherLinks?.map((link, index) => (
              <a 
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.purchaseLink}
              >
                <div className={styles.linkIcon}>🔗</div>
                <div className={styles.linkInfo}>
                  <span className={styles.linkTitle}>{link.name}</span>
                </div>
                <FaExternalLinkAlt className={styles.linkArrow} />
              </a>
            ))}
          </div>
        </div>
      )}
      
      {/* Maintenance Information */}
      {equipment.maintenanceInfo && (
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>
            <FaTools /> Maintenance Information
          </h3>
          <p className={styles.maintenanceInfo}>{equipment.maintenanceInfo}</p>
        </div>
      )}
      
      {/* Related Equipment */}
      {equipment.relatedEquipment && equipment.relatedEquipment.length > 0 && (
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Related Equipment</h3>
          <div className={styles.relatedItems}>
            {equipment.relatedEquipment.map((item, index) => (
              <div key={index} className={styles.relatedItem}>
                {typeof item === 'string' ? item : item.equipmentName}
              </div>
            ))}
          </div>
        </div>
      )}
      
      {/* Additional Notes */}
      {equipment.notes && (
        <div className={styles.section}>
          <h3 className={styles.sectionTitle}>Additional Notes</h3>
          <p className={styles.notes}>{equipment.notes}</p>
        </div>
      )}
    </div>
  );
};

OverviewTab.propTypes = {
  equipment: PropTypes.object.isRequired
};

export default OverviewTab;

